import { createBrowserRouter }  from "react-router-dom";

// import DonationPage             from "../Pages/Main/donate/DonationPage";
import SliderDetails            from "../Pages/Main/Components/SliderDetails/SliderDetails";

// import Register                 from "../Pages/Main/auth/Register";
import InvolveDetails from "../Pages/Main/getInvolved/InvolveDetails";
import OurProgram from "../Pages/Main/ourProgram/OurProgram";
import OurProgramDetails from "../Pages/Main/ourProgram/OurProgramDetails";
import ServiceSliderDetails from "../Pages/Main/Components/SliderDetails/ServiceSliderDetails";
import DiasporaCommunity from "../Pages/Main/diasporaCommunity/DiasporaCommunity";
import ReligionTax from "../Pages/Main/religionTax/ReligionTax";
import { lazy } from "react";
import ChangePassword from "../Pages/UsersPortal/components/settings/ChangePassword";
import { ReligionTaxContextProvider } from "../Context/ReligionTaxAmountContext";

const Index                     = lazy(() => import("../Pages/Main/mainPage/Index"));
// import Index                    from "../Pages/Main/mainPage/Index";
const About                     = lazy(() => import("../Pages/Main/about/About"));
// import About                    from "../Pages/Main/about/About";
const WomenEmpowerment          = lazy(() => import("../Pages/Main/womenEmpowerment/WomenEmpowerment"));
// import WomenEmpowerment         from "../Pages/Main/womenEmpowerment/WomenEmpowerment";
// const Transparency              = lazy(() => import("../Pages/Main/transparency/Transparency"));
// const SustainableDevelopment    = lazy(() => import("../Pages/Main/sustainable/SustainableDevelopment"));
const AgriculturesIrrigation    = lazy(() => import("../Pages/Main/whatWeDo/agricultures"));
// import AgriculturesIrrigation   from "../Pages/Main/whatWeDo/agricultures";
const Internship                = lazy(() => import("../Pages/Main/internship/Internships"));
// import Internship               from "../Pages/Main/internship/Internships";
const StartUpCompetition        = lazy(() => import("../Pages/Main/startUps/Startup"));
// import StartUpCompetition       from "../Pages/Main/startUps/Startup";
const Business                  = lazy(() => import("../Pages/Main/BusinessAid/BusinessAid"));
// import Business                 from "../Pages/Main/BusinessAid/BusinessAid";
const Main                      = lazy(() => import("../Pages/Main/Main"));
// import Main                     from "../Pages/Main/Main";
const EconomicDevelopment       = lazy(() => import("../Pages/Main/whatWeDo/economicDevelopment"));
// import EconomicDevelopment      from "../Pages/Main/whatWeDo/economicDevelopment";
const SocialServices            = lazy(() => import("../Pages/Main/whatWeDo/socialServices"));
// import SocialServices           from "../Pages/Main/whatWeDo/socialServices";
// const Educations                = lazy(() => import("../Pages/Main/whatWeDo/educations"));
// import Educations               from "../Pages/Main/whatWeDo/educations";
// const HealthServices            = lazy(() => import("../Pages/Main/whatWeDo/healthServices"));
const WebsiteUrgentAid          = lazy(() => import("../Pages/Main/urgent-aid/UrgentAid"));
// import WebsiteUrgentAid         from "../Pages/Main/urgent-aid/UrgentAid";
const WebsiteChildLabour        = lazy(() => import("../Pages/Main/child-labour/ChildLabour"));
// import WebsiteChildLabour       from "../Pages/Main/child-labour/ChildLabour";
const GetInvolved               = lazy(() => import("../Pages/Main/getInvolved/GetInvolved"));
// import GetInvolved              from "../Pages/Main/getInvolved/GetInvolved";
const Donate                    = lazy(() => import("../Pages/Main/donate/Donate"));
// import Donate                   from "../Pages/Main/donate/Donate";

//*******PrivateRoutes******* */
const InNeedFamilyDetails       = lazy(() => import("../Pages/UsersPortal/InNeedPeoples/InNeedFamilyDetails"));
// import InNeedFamilyDetails      from "../Pages/UsersPortal/InNeedPeoples/InNeedFamilyDetails";

// import CourseIndex              from "../Pages/UsersPortal/courses/CourseIndex";
const CourseIndex = lazy(() => import("../Pages/UsersPortal/courses/CourseIndex"));

// import MainDashboard            from "../Pages/UsersPortal/courses/components/MainDashboard";

//*****************Home page services components*********************** */
const Home                      = lazy(() => import("../Pages/UsersPortal/home"));
// import Home                     from "../Pages/UsersPortal/home";

const HomeIndex = lazy(() => import("../Pages/UsersPortal/main/homeIndex"));
// import HomeIndex                from "../Pages/UsersPortal/main/homeIndex";

const Profile                   = lazy(() => import("../Pages/UsersPortal/profile/profile"));
// import Profile                  from "../Pages/UsersPortal/profile/profile";

const UrgentAid                 = lazy(() => import("../Pages/UsersPortal/hdnServices/urgentAid/UrgentAid"));
// import UrgentAid                from "../Pages/UsersPortal/hdnServices/urgentAid/UrgentAid";

const RegisterNewUrgent         = lazy(() => import("../Pages/UsersPortal/hdnServices/urgentAid/RegisterNewUrgent"));
// import RegisterNewUrgent        from "../Pages/UsersPortal/hdnServices/urgentAid/RegisterNewUrgent";

const InNeedByProvince          = lazy(() => import("../Pages/UsersPortal/hdnServices/urgentAid/InNeedByProvince"));
// import InNeedByProvince         from "../Pages/UsersPortal/hdnServices/urgentAid/InNeedByProvince";

const HdnServicesIndex          = lazy(() => import("../Pages/UsersPortal/hdnServices/HdnServicesIndex"));
// import HdnServicesIndex         from "../Pages/UsersPortal/hdnServices/HdnServicesIndex";

const UrgentAidIndex            = lazy(() => import("../Pages/UsersPortal/hdnServices/urgentAid/UrgentAidIndex"));
// import UrgentAidIndex           from "../Pages/UsersPortal/hdnServices/urgentAid/UrgentAidIndex";

const TakeCourse                = lazy(() => import("../Pages/UsersPortal/hdnServices/internships/TakeCourse"));
// import TakeCourse               from "../Pages/UsersPortal/hdnServices/internships/TakeCourse";

const InternshipCourseDetails   = lazy(() => import("../Pages/UsersPortal/hdnServices/internships/InternshipCourseDetails"));
// import InternshipCourseDetails  from "../Pages/UsersPortal/hdnServices/internships/InternshipCourseDetails";

const InternshipDetails         = lazy(() => import("../Pages/UsersPortal/hdnServices/internships/InternshipDetails"));
// import InternshipDetails        from "../Pages/UsersPortal/hdnServices/internships/InternshipDetails";


const StartUpUploadDoc = lazy(() => import("../Pages/UsersPortal/hdnServices/startUps/StartUpUploadDoc"));
// import StartUpUploadDoc         from "../Pages/UsersPortal/hdnServices/startUps/StartUpUploadDoc";

const ProjectReport = lazy(() => import("../Pages/UsersPortal/TrackDonationProjectReports/ProjectReport"));
// import ProjectReport            from "../Pages/UsersPortal/TrackDonationProjectReports/ProjectReport";

const DonationDetails = lazy(() => import("../Pages/UsersPortal/userDonation/DonationDetails"));
// import DonationDetails          from "../Pages/UsersPortal/userDonation/DonationDetails";

const DonationDetailsTable = lazy(() => import("../Pages/UsersPortal/userDonation/DonationDetailsTable"));
// import DonationDetailsTable     from "../Pages/UsersPortal/userDonation/DonationDetailsTable";

const CompletedProject          = lazy(() => import("../Pages/UsersPortal/completedProjects/CompletedProject"));
// import CompletedProject         from "../Pages/UsersPortal/completedProjects/CompletedProject";

const BusinessAid               = lazy(() => import("../Pages/UsersPortal/hdnServices/businessAid/BusinessAid"));
// import BusinessAid              from "../Pages/UsersPortal/hdnServices/businessAid/BusinessAid";

const AgricultureAndLiveStockService = lazy(() => import("../Pages/UsersPortal/hdnServices/agriculture&Livestock/AgricultureAndLiveStockService"));
// import AgricultureAndLiveStockService from "../Pages/UsersPortal/hdnServices/agriculture&Livestock/AgricultureAndLiveStockService";


const ChildLabour               = lazy(() => import("../Pages/UsersPortal/hdnServices/childLabour/ChildLabour"));
// import ChildLabour              from "../Pages/UsersPortal/hdnServices/childLabour/ChildLabour";

const FamilyDetailsForDonation  = lazy(() => import("../Pages/UsersPortal/hdnServices/urgentAid/FamilyDetailsForDonation"));
// import FamilyDetailsForDonation from "../Pages/UsersPortal/hdnServices/urgentAid/FamilyDetailsForDonation";

const MainPage                  = lazy(() => import("../Pages/UsersPortal/courses/MainPage"));
// import MainPage                 from "../Pages/UsersPortal/courses/MainPage";

const CourseContent             = lazy(() => import("../Pages/UsersPortal/courses/components/CourseContent"));
// import CourseContent            from "../Pages/UsersPortal/courses/components/CourseContent";


const UrgentDetails             = lazy(() => import("../Pages/UsersPortal/hdnServices/urgentAid/UrgentDetails"));
// import UrgentDetails            from "../Pages/UsersPortal/hdnServices/urgentAid/UrgentDetails";

const Salaries                  = lazy(() => import("../Pages/UsersPortal/salaries/Salaries"));
// import Salaries                 from "../Pages/UsersPortal/salaries/Salaries";

const SalaryDetails             = lazy(() => import("../Pages/UsersPortal/salaries/SalaryDetails"));
// import SalaryDetails            from "../Pages/UsersPortal/salaries/SalaryDetails";

const PageNotFound              = lazy(() => import("../Components/404/notFound"));
// import PageNotFound             from "../Components/404/notFound";


const MainDashboard             = lazy(() => import("../Pages/UsersPortal/courses/components/MainDashboard"));

const Register = lazy(() => import("../Pages/Main/auth/Register"));


const routeArray = [
  {
    path: "/invited/sign-up/:id/:token",
    element: <Register />,
  },
  {
    path: "/",
    element: (
      <Main />
    ),
    errorElement: <PageNotFound homeUrl="/" />,
    children: [
      {
        path: "/",
        index: true,
        element: <Index />,
      },
      {
        path: "/about-us",
        element: <About />,
      },
      {
        path: "/economic-development-services",
        element: <EconomicDevelopment />,
      },
      // {
      //   path: "/education-services",
      //   element: <Educations />,
      // },
      {
        path: "/social-services",
        element: <SocialServices />,
      },
      // {
      //   path: "/health-services",
      //   element: <HealthServices />,
      // },
      {
        path: "/agriculture-and-livestock",
        element: <AgriculturesIrrigation />,
      },
      {
        path: "internships",
        element: <Internship />,
      },
      {
        path: "start-ups",
        element: <StartUpCompetition />,
      },
      {
        path: "business-aid",
        element: <Business />,
      },
      // {
      //   path: "donate",
      //   element: <Donate />,
      // },
      {
        path: "/donate",
        element: <Donate />,
      },
      {
        path: "religion-tax",
        element:<ReligionTaxContextProvider><ReligionTax/></ReligionTaxContextProvider>
      },
        
      {
        path: "women-empowerment",
        element: <WomenEmpowerment />,
      },
      {
        path: "economic-development",
        element: <EconomicDevelopment />,
      },
      // {
      //   path: "about-transparency",
      //   element: <Transparency />,
      // },
      // {
      //   path: "sustainable-development",
      //   element: <SustainableDevelopment />,
      // },
      {
        path: "diaspora-community",
        element: <DiasporaCommunity />,
      },
      {
        path: "urgent-aid",
        element: <WebsiteUrgentAid />,
      },
      {
        path: "child-labour",
        element: <WebsiteChildLabour />,
      },
      {
        path: "get-involved",
        element: <GetInvolved />,
      },
      {
        path: "involve-details/:id",
        element: <InvolveDetails />,
      },
      {
        path: "our-program",
        element: <OurProgram />,
      },
      {
        path: "our-program-details/:id",
        element: <OurProgramDetails />,
      },
      {
        path: "services-detail/:id",
        element: <ServiceSliderDetails/>,
      },
      
      {
        path: ":title/details/:id",
        element: <SliderDetails />,
      },
      {
        path: "*",
        element: <PageNotFound homeUrl="/" />,
      },
    ],
  },

  //   Home routes
  {
    path: "/home/*",
    element: (
      <Home />
    ),
    children: [
      {
        index: true,
        animate: true,
        element: (
          <HomeIndex />
        ),
      },
      {
        animate: true,
        path: "profile",
        element: (
          <Profile />
        ),
      },
      {
        path: "in-need-family/:id",
        element: <InNeedFamilyDetails />,
      },
      {
        path: "settings/change-password",
        element: <ChangePassword />,
      },
      {
        path: "course-list",
        element: <Profile />,
      },
      {
        path: "salaries",
        element: <Salaries />,
      },
      {
        path: "salaries/:id/salary-details",
        element: <SalaryDetails />,
      },

      //*******Services routes******** */
      {
        path: "services/*",
        element: <HdnServicesIndex />,
        // index:true,
        children: [
          {
            path: "urgent-aids",
            element: <UrgentAidIndex />,
            children: [
              {
                index: true,
                element: <UrgentAid />,
              },
              {
                path: "new-urgent",
                element: <RegisterNewUrgent />,
              },
              {
                path: "urgent-by-province/:provinceCode/:provinceName",
                element: <InNeedByProvince />,
              },
              {
                path: ":id/details",
                element: <FamilyDetailsForDonation />,
              },
              {
                path: ":urgentId/family-details",
                element: <UrgentDetails />,
              },
            ],
          },
          // ********Urgent Aid Routes********/
          {
            path: "internships",
            element: <InternshipDetails />,
          },
          {
            path: "internships/take-course",
            element: <TakeCourse />,
          },
          {
            path: "internships/take-course/:title/:id",
            element: <InternshipCourseDetails />,
          },
          {
            path: "startup",
            element: <StartUpUploadDoc />,
          },
          {
            path: "business-aids",
            element: <BusinessAid />,
          },
          {
            path: "agriculture-livestock",
            element: <AgricultureAndLiveStockService />,
          },
          {
            path: "child-labour",
            element: <ChildLabour />,
          },
        ],
      },
      // *******User donation reports*********/
      {
        path: "track-project-report",
        element: <ProjectReport />,
      },
      {
        path: "my-donation-list",
        element: <DonationDetailsTable />,
      },
      {
        path: "my-donation-list/:id/details",
        element: <DonationDetails />,
      },
      // *******Completed Projects report*********/
      {
        path: "completed-projects/:id/details",
        element: <CompletedProject />,
      },
      {
        path: "my-course/list",
        element: <PageNotFound />,
      },
      // {
      //   path: "stepper",
      //   element: <Step />,
      // },
      {
        path: "*",
        element: <PageNotFound homeUrl="/home" />,
      },
    ],
  },

  // courses route main page
  {
    path: "/courses",
    element: (
        <MainPage />
    ),
    children: [
      {
        index: true,
        element: <MainDashboard />,
      },
    ],
  },

  // courses routes course panel
  {
    path: "/courses/:title/:id",
    element: (
      <CourseIndex />
    ),
    children: [
      {
        index: true,
        element: <CourseIndex />,
      },
      {
        path: ":lessonId",
        element: <CourseContent />,
      },
    ],
  },
];
// const routes = createBrowserRouter(routeArray);
const routes = createBrowserRouter(routeArray,{basename:"/"});

export default routes;